import { useContext, useState } from 'react';
import { Button, ButtonToolbar } from 'reactstrap';
import { mapModes } from '../../constants/map';
import { MapContext } from '../../contexts/MapContext';
import DeletingToolbar from './DeletingToolbar';
import { asQuantityWithUnit } from '../../utils/formatters';
import CreateSectionGroupButton from './buttons/CreateSectionGroupButton';

const MultiSectionToolbar = () => {
  const {
    fields: { removeFieldSection },
    mapState: { setMapMode, selectedFieldIds },
  } = useContext(MapContext);

  const [deleting, setDeleting] = useState(false);

  const name = asQuantityWithUnit('sections', 'section')(selectedFieldIds.size);

  if (deleting) {
    return (
      <DeletingToolbar
        name={name}
        onCancel={() => {
          setDeleting(false);
        }}
        onConfirm={() => {
          selectedFieldIds.forEach((id) => {
            removeFieldSection(id);
          });
          setMapMode(mapModes.VIEW);
        }}
      />
    );
  }

  return (
    <ButtonToolbar className="d-flex align-items-center">
      <div className="mr-2 font-weight-bold">{name}</div>
      <Button
        onClick={() => setDeleting(true)}
        size="sm"
        outline
        className="mr-2"
      >
        Delete Selected
      </Button>
      <CreateSectionGroupButton />
      <Button onClick={() => setMapMode(mapModes.VIEW)} size="sm">
        Cancel
      </Button>
    </ButtonToolbar>
  );
};

export default MultiSectionToolbar;
